var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","items":_vm.visitas,"fields":_vm.fields}}),(_vm.visitas[0])?_c('b-progress',{staticClass:"my-3",attrs:{"max":_vm.visitas[0].total,"height":"2rem"}},[_c('b-progress-bar',{attrs:{"variant":"info","value":_vm.visitas[0].espontaneos,"show-progress":"","label":("Espontâneos [" + ((
        (_vm.visitas[0].espontaneos / _vm.visitas[0].total) *
        100
      ).toFixed(0)) + "%]")}}),_c('b-progress-bar',{attrs:{"variant":"primary","value":_vm.visitas[0].agendados,"show-progress":"","label":("Agendados [" + ((
        (_vm.visitas[0].agendados / _vm.visitas[0].total) *
        100
      ).toFixed(0)) + "%]")}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }